import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import './styles/iview.less'
import './styles/main.styl'
import App from './app'
import store from './store'
import router from './router'
import filters from './filters'
import { assets } from './config'
import wj from './plugins/wjtools'
import * as api from './api'
Vue.use(ElementUI)
Vue.config.productionTip = false

Vue.prototype.$api = api
Vue.prototype.$wj = wj
Vue.prototype.$util = wj.util
Vue.prototype.$assets = assets

filters(Vue) // 注册全局过滤器

// 创建应用实例
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
